export const menuList = [
    { label: "Today's Steals", href: '/search?keywords=today,steal' },
    { label: 'Popular', href: '/search?keywords=popular' },
    { label: 'Home Improvement', href: '/search?keywords=home,improvement' },
    { label: 'Outdoor', href: '/search?keywords=outdoor' },
    { label: 'Trending Furniture', href: '/search?keywords=trending,furniture' },
    { label: 'Locations Map', href: '/locationmap' },
]

export const authList = [
    { label: 'All Listings', href: '/search' },
    //{ label: 'Live Auctions', href: '/auction' },
]

export const pageOptions = [
    {
        value: 0,
        show: 'All',
    },
    {
        value: 1,
        show: 'Beauty',
    },
    {
        value: 2,
        show: 'Jewelry',
    },
    {
        value: 3,
        show: 'Tools',
    },
    {
        value: 4,
        show: 'Clothing',
    },
    {
        value: 5,
        show: 'Outdoors',
    },
    {
        value: 6,
        show: 'Pet Supplies',
    },
    {
        value: 7,
        show: 'Office',
    },
    {
        value: 8,
        show: 'Housewares',
    },
    {
        value: 9,
        show: 'Musical Instruments',
    },
    {
        value: 10,
        show: 'Movies',
    },
]

export const profileTabs = [
    {
        index: 0,
        label: 'Profile',
    },
    {
        index: 1,
        label: 'Change Password',
    },
    {
        index: 2,
        label: 'My Notifications',
    },
    // {
    //     index: 3,
    //     label: 'Payment',
    // },
]
export const accountTabs = [
    {
        index: 0,
        label: 'Manage Credit Cards',
    },
    {
        index: 1,
        label: 'Password & Security',
    },
]
export const myInterests = [
    {
        id: 1,
        value: 1,
        label: 'Beauty - Health - Medical',
    },
    {
        id: 2,
        value: 2,
        label: 'Housewares - Small Appliances',
    },
    {
        id: 3,
        value: 3,
        label: 'Outdoors - Sporting Goods',
    },
    {
        id: 4,
        value: 4,
        label: 'Bedding - Towels - Pillows',
    },
    {
        id: 5,
        value: 5,
        label: 'Jewelry - Watches',
    },
    {
        id: 6,
        value: 6,
        label: 'Outdoors - Sporting Goods',
    },
    {
        id: 7,
        value: 7,
        label: 'Clothing - Accessories',
    },
    {
        id: 8,
        value: 8,
        label: 'Large Appliances',
    },
    {
        id: 9,
        value: 9,
        label: 'Plumbing',
    },
    {
        id: 10,
        value: 10,
        label: 'Commercial - Industrial',
    },
    {
        id: 11,
        value: 11,
        label: 'Lawn - Garden - Home Improvement',
    },
    {
        id: 12,
        value: 12,
        label: 'Seasonal Items',
    },
    {
        id: 13,
        value: 13,
        label: 'Electronics - Tv - Camera',
    },
    {
        id: 14,
        value: 14,
        label: 'Movies - Music - Video Games',
    },
    {
        id: 15,
        value: 15,
        label: 'Tools - Garage',
    },
    {
        id: 16,
        value: 16,
        label: 'Furniture',
    },
    {
        id: 17,
        value: 17,
        label: 'Musical Instruments',
    },
    {
        id: 18,
        value: 18,
        label: 'Toys - Hobbies',
    },
    {
        id: 19,
        value: 19,
        label: 'Grocery Items',
    },
    {
        id: 20,
        value: 20,
        label: 'Odds & Ends - Misc',
    },
    {
        id: 21,
        value: 21,
        label: 'Toys - Kids - Baby',
    },
    {
        id: 22,
        value: 22,
        label: 'Home Decor - Lighting',
    },
    {
        id: 23,
        value: 23,
        label: 'Office Furniture - Supplies',
    },
    {
        id: 24,
        value: 24,
        label: 'Wall Art - Mirrors - Clocks',
    },
]

export const filterCategories = [
    {
        id: 1,
        label: 'Beauty',
        img_src: '/assets/svg/beauty.svg',
    },
    {
        id: 2,
        label: 'Jewelry',
        img_src: '/assets/svg/jewlery.svg',
    },
    {
        id: 3,
        label: 'Tools',
        img_src: '/assets/svg/hammer.svg',
    },
    {
        id: 4,
        label: 'Clothing',
        img_src: '/assets/svg/clothing.svg',
    },
    {
        id: 5,
        label: 'Outdoors',
        img_src: '/assets/svg/outdoors.svg',
    },
    {
        id: 6,
        label: 'Pet Supplies',
        img_src: '/assets/svg/pets.svg',
    },
    {
        id: 7,
        label: 'Office',
        img_src: '/assets/svg/Printer.svg',
    },
    {
        id: 8,
        label: 'Jewelry',
        img_src: '/assets/svg/bulb.svg',
    },
    {
        id: 9,
        label: 'Housewares',
        img_src: '/assets/svg/houseware.svg',
    },
    {
        id: 10,
        label: 'Musical Instruments',
        img_src: '/assets/svg/Guitar.svg',
    },
    {
        id: 11,
        label: 'Movies',
        img_src: '/assets/svg/FilmReel.svg',
    },
    {
        id: 12,
        label: 'Pet Supplies',
        img_src: '/assets/svg/ForkKnife.svg',
    },
]

export const orderTabs = [
    {
        index: 0,
        label: 'Orders',
    },
    {
        index: 1,
        label: 'Returns',
    },
]

export const warehouse_locations = [
    {
        id: 24,
        business_name: 'Richardson',
        address: '1221 westcampell road',
        city: 'Richardson',
        state: 'Texas',
        country: 'United States',
        zip: 75080,
    },
    {
        id: 24,
        business_name: 'Richardson',
        address: '1221 westcampell road',
        city: 'Richardson',
        state: 'Texas',
        country: 'United States',
        zip: 75080,
    },
    {
        id: 24,
        business_name: 'Richardson',
        address: '1221 westcampell road',
        city: 'Richardson',
        state: 'Texas',
        country: 'United States',
        zip: 75080,
    },
    {
        id: 24,
        business_name: 'Richardson',
        address: '1221 westcampell road',
        city: 'Richardson',
        state: 'Texas',
        country: 'United States',
        zip: 75080,
    },
]

export const usersData = [
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
    {
        id: 1024,
        first_name: 'Muhammed',
        last_name: 'Roshan',
        email: 'test17.auctionsoftware+jan22@gmail.com',
        last_login: '02-02-2024',
        status: 'Active',
    },
]

export const erpData = [
    {
        lot_id: 101,
        product_id: 234234,
        lot_number: 34567,
        avatar: '',
        inventory_number: '...',
        category: 'Collectibles >> Other Collectibles',
        condition: 'Good',
        title: 'Mobius',
        description: 'Test lot data test lot data',
    },
    {
        lot_id: 101,
        product_id: 234234,
        lot_number: 34567,
        avatar: '',
        inventory_number: '...',
        category: 'Collectibles >> Other Collectibles',
        condition: 'Good',
        title: 'Mobius',
        description: 'Test lot data test lot data',
    },
    {
        lot_id: 101,
        product_id: 234234,
        lot_number: 34567,
        avatar: '',
        inventory_number: '...',
        category: 'Collectibles >> Other Collectibles',
        condition: 'Good',
        title: 'Mobius',
        description: 'Test lot data test lot data',
    },
    {
        lot_id: 101,
        product_id: 234234,
        lot_number: 34567,
        avatar: '',
        inventory_number: '...',
        category: 'Collectibles >> Other Collectibles',
        condition: 'Good',
        title: 'Mobius',
        description: 'Test lot data test lot data',
    },
]

export const pickupData = [
    {
        name: 'Muhammed',
        phone: '4567898021',
        email: 'MuhammedRoshan@gmail.com',
        invoice_num: 100123,
        time_waited: '30m',
        order_date: '01/22/2024',
        status: 'booking',
    },
    {
        name: 'Muhammed',
        phone: '4567898021',
        email: 'MuhammedRoshan@gmail.com',
        invoice_num: 100123,
        time_waited: '30m',
        order_date: '01/22/2024',
        status: 'waitlist',
    },
    {
        name: 'Muhammed',
        phone: '4567898021',
        email: 'MuhammedRoshan@gmail.com',
        invoice_num: 100123,
        time_waited: '30m',
        order_date: '01/22/2024',
        status: 'waitlist',
    },
    {
        name: 'Muhammed',
        phone: '4567898021',
        email: 'MuhammedRoshan@gmail.com',
        invoice_num: 100123,
        time_waited: '30m',
        order_date: '01/22/2024',
        status: 'completed',
    },
    {
        name: 'Muhammed',
        phone: '4567898021',
        email: 'MuhammedRoshan@gmail.com',
        invoice_num: 100123,
        time_waited: '30m',
        order_date: '01/22/2024',
        status: 'completed',
    },
]

export const orderData = [
    {
        id: 1,
        img_src: '/assets/images/noImage.png',
        product_title: 'Haul-Master 500 lb. Steel Cargo Carrier',
        location: 'A1',
        price: 32.5,
        buyer_premium: 3.5,
        per_tax: 3.5,
    },
    {
        id: 2,
        img_src: '/assets/images/noImage.png',
        product_title: 'Haul-Master 500 lb. Steel Cargo Carrier',
        location: 'B1',
        price: 32.5,
        buyer_premium: 3.5,
        per_tax: 3.5,
    },
    {
        id: 1,
        img_src: '/assets/images/noImage.png',
        product_title: 'Haul-Master 500 lb. Steel Cargo Carrier',
        location: 'C1',
        price: 32.5,
        buyer_premium: 3.5,
        per_tax: 3.5,
    },
]

export const customToastMessageColors = {
    gold: {
        backgroundColor: '#9c27b0',
        color: 'white',
        '& .SnackbarContent-root': {
            backgroundColor: '#9c27b0 !important',
        },
    },
    success: {
        backgroundColor: '#9c27b0',
        color: 'white',
        '& .SnackbarContent-root': {
            backgroundColor: '#9c27b0 !important',
        },
    },
}
